module.exports = function (app, mod) {
  return "<div class=\"main\">\n\t\t\t\t<div id=\"board\"></div>\n\t\t\t\t<div id=\"game-playerbox-manager\" class=\"game-playerbox-manager\"></div>\n\t\t\t</div>";
};